import { FGGridContainer, FGGridItem, FGLink } from '@fg/design-system';

export const DisclaimerFooter = () => {
  return (
    <div style={{ padding: '8px' }}>
      <FGGridContainer containerPadding={0}>
        <FGGridItem sm={5} xs={12}>
          <div className="fg-body4">
            Fitch Ratings PRO is offered by
            <FGLink
              href="https://www.fitchsolutions.com/credit"
              style={{ 'fontSize': 'var(--fg-web-body-4-long-font-size)' }}
              appearance="blue"
            >
              &nbsp;Fitch Ratings Research & Data
            </FGLink>
            , a business unit of Fitch Solutions. Fitch Ratings Research & Data, a Fitch Ratings sister business, helps
            credit, risk, and investment professionals make better-informed decisions and meet regulatory requirements,
            within and beyond the rated universe. Fitch Solutions, Inc. is a Fitch Group company.
          </div>
        </FGGridItem>
      </FGGridContainer>
    </div>
  );
};